import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsTicketingDetails from "./components/SettingsTicketingDetails";

const SettingsTicketingDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsTicketingDetails {...props} />
    </>
  );
};

export default SettingsTicketingDetailsApp;
